const ROOT_SELECTOR = '[data-lunala-secure-delivery]';
const ETA_SELECTOR = '[data-secure-delivery-eta]';
const STORAGE_KEY = 'lunalaSecureDeliveryLocation';
const STORAGE_TTL = 24 * 60 * 60 * 1000;
let locationPromise;

const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

const formatWeekday = (date) => {
  const weekday = new Intl.DateTimeFormat('pt-BR', { weekday: 'long' }).format(date);
  return weekday.charAt(0).toLocaleUpperCase('pt-BR') + weekday.slice(1);
};

const formatDay = (date) => new Intl.DateTimeFormat('pt-BR', { day: '2-digit' }).format(date);

const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');

const readCachedLocation = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return '';

    const cached = JSON.parse(raw);
    if (!cached.location || !cached.timestamp) return '';
    if (Date.now() - cached.timestamp > STORAGE_TTL) return '';

    return cached.location;
  } catch (_error) {
    return '';
  }
};

const writeCachedLocation = (location) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        location,
        timestamp: Date.now(),
      })
    );
  } catch (_error) {
    return '';
  }
};

const formatLocation = (data) => {
  const city = normalizeText(data.city);
  const region = normalizeText(data.region_code || data.region);

  if (city && region) return `${city} (${region.toLocaleUpperCase('pt-BR')})`;
  if (city) return city;
  if (region) return region.toLocaleUpperCase('pt-BR');

  return '';
};

const fetchLocation = async () => {
  const cachedLocation = readCachedLocation();
  if (cachedLocation) return cachedLocation;

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 2200);

  try {
    const response = await fetch('https://ipapi.co/json/', {
      signal: controller.signal,
    });

    if (!response.ok) return '';

    const data = await response.json();
    const location = formatLocation(data);

    if (location) writeCachedLocation(location);

    return location;
  } catch (_error) {
    return '';
  } finally {
    window.clearTimeout(timeout);
  }
};

const getLocation = () => {
  if (!locationPromise) {
    locationPromise = fetchLocation();
  }

  return locationPromise;
};

const buildDeliveryText = (element, location) => {
  const template =
    element.dataset.template ||
    'Receba entre {start_weekday} ({start_day}) e {end_weekday} ({end_day}) em {location}';
  const minimumDays = Number.parseInt(element.dataset.minDays, 10) || 15;
  const maximumDays = Number.parseInt(element.dataset.maxDays, 10) || 20;
  const today = new Date();
  const startDate = addDays(today, minimumDays);
  const endDate = addDays(today, maximumDays);
  const replacements = {
    start_weekday: formatWeekday(startDate),
    start_day: formatDay(startDate),
    end_weekday: formatWeekday(endDate),
    end_day: formatDay(endDate),
    location: location || element.dataset.locationFallback || '',
  };

  return template.replace(/\{([a-z_]+)\}/g, (_match, key) => replacements[key] || '');
};

const renderDeliveryEstimate = (location = '') => {
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    const eta = root.querySelector(ETA_SELECTOR);
    if (!eta) return;

    eta.textContent = buildDeliveryText(eta, location || eta.dataset.locationFallback);
  });
};

const initialize = () => {
  renderDeliveryEstimate();

  getLocation().then((location) => {
    if (!location) return;

    renderDeliveryEstimate(location);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}

document.addEventListener('shopify:section:load', initialize);
